/* Ourkids cart drawer live-sync fix.
   The drawer's built-in refresher single-flights on an in-flight slot, but the
   code that clears the slot is unreachable (it sits after a return statement),
   so whatever it rendered first -- often fetched before the add even landed --
   is served forever while the badge keeps counting. This independent refresher
   re-fetches the drawer section after every cart mutation settles and swaps
   the fresh pieces in, using the same swap contract as the original. */
(function () {
  if (window.okCartFix) return; window.okCartFix = true;

  function sectionEl() {
    return document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
  }

  var pending = null, again = false;

  function swap(el, src) {
    ['cart-items', '.drawer__footer', '.cart-drawer__footer', '.drawer__header', '.totals']
      .forEach(function (sel) {
        var to = el.querySelector(sel), from = src.querySelector(sel);
        if (!to || !from) return;
        to.innerHTML = from.innerHTML;
        to.className = from.className;
      });
    /* empty/filled state travels on id'd containers' class lists */
    src.querySelectorAll('[id]').forEach(function (from) {
      var to = el.querySelector('[id="' + from.id.replace(/"/g, '\\"') + '"]');
      if (to && to.className !== from.className) to.className = from.className;
    });
    var fdTo = el.querySelector('[data-okfd]'), fdFrom = src.querySelector('[data-okfd]');
    if (fdTo && fdFrom) fdTo.outerHTML = fdFrom.outerHTML;
    else if (fdTo && !fdFrom) fdTo.remove();
  }

  function refresh() {
    if (pending) { again = true; return pending; }
    var el = sectionEl();
    if (!el || !window.fetch) return Promise.resolve();
    var sid = el.id.replace('shopify-section-', '');
    function settled(r) {
      pending = null;
      if (again) { again = false; return refresh(); }
      return r;
    }
    pending = fetch('/?sections=' + encodeURIComponent(sid) + '&_=' + Date.now(), {
      headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[sid]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]') || doc.body;
        var live = sectionEl();
        if (live) swap(live, src);
      })
      .catch(function () {})
      .then(settled, settled);
    return pending;
  }

  function counts() {
    fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('cart-count,.cart-count,[data-cart-count],.cart-count-bubble,.header__cart-count')
          .forEach(function (el) {
            var t = el.querySelector('span') || el;
            t.textContent = c.item_count;
            if (c.item_count > 0) { el.removeAttribute('hidden'); el.classList.remove('hidden', 'is-empty'); }
          });
      }).catch(function () {});
  }

  var t = null;
  function soon() {
    clearTimeout(t);
    t = setTimeout(function () { refresh(); counts(); }, 150);
  }

  var orig = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var mutates = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var out = orig.apply(this, arguments);
    if (mutates) out.then(function (r) { if (r && r.ok) soon(); }).catch(function () {});
    return out;
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/(add|change|update)/.test(f.action)) soon();
  }, true);

  /* keep content fresh on the closed->open edge too, in case a mutation was missed */
  var was = false;
  setInterval(function () {
    if (document.hidden) return;
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var cs = getComputedStyle(d);
    var now = cs.display !== 'none' && cs.visibility !== 'hidden' && cs.pointerEvents !== 'none';
    if (now && !was) { refresh(); counts(); }
    was = now;
  }, 300);

  /* --- PDP fixes (ok-main-product "You may also like" + pickup pill) -------
     1. Size-picker used to float as an absolute bubble over the card title.
        Now an inline row inside the card, with a "PICK A SIZE" caption, and it
        closes itself after a size is added.
     2. "collect today at our Dokki branch" stranded "branch" on its own line,
        and the pill inherits the theme's fixed 48px button height so two lines
        overflowed the border. Bold phrase is now unbreakable and the pill
        grows. */
  var st = document.createElement('style');
  st.textContent =
    '.okp-up__card{flex-wrap:wrap;}' +
    '.okp-up__sizes{position:static !important;right:auto !important;bottom:auto !important;' +
      'flex-basis:100%;order:9;max-width:none !important;justify-content:flex-start !important;' +
      'box-shadow:none !important;border:0 !important;border-top:1px dashed #E2E8F0 !important;' +
      'border-radius:0 !important;padding:8px 0 0 !important;margin:2px 0 0 !important;' +
      'background:transparent !important;}' +
    '.okp-up__sizes::before{content:"Pick a size";flex-basis:100%;font-size:10.5px;' +
      'font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:#6B7280;}' +
    '.okp-pickup__txt > span b{white-space:nowrap !important;}' +
    '.okp-pickup{height:auto !important;min-height:48px !important;grid-template-rows:auto !important;}';
  (document.head || document.documentElement).appendChild(st);

  /* after a size chip adds to cart (the chip shows ... then a check for 1.2s),
     fold the size row away and reset the pill so the card returns to rest */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.okp-up__size');
    if (!chip) return;
    var box = chip.closest('.okp-up__sizes');
    var card = box && box.closest('.okp-up__card');
    var pick = card && card.querySelector('[data-okp-pick]');
    setTimeout(function () {
      if (box) box.hidden = true;
      if (pick) pick.textContent = '+';
    }, 1400);
  }, true);
})();
